var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  Screen: () => Screen
});
var import_definition = __toModule(require("../definition"));
var import_constants = __toModule(require("../constants"));
var import_yayoyakiValidator = __toModule(require("../yayoyakiValidator"));
class Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    this.screenForm = samaForm.getScreenForm(screenName);
    this.samaForm = samaForm;
  }
  getBannerData() {
    const { body, helpButtonUrl, requirement, type } = this.screenForm.bannerData || {};
    if (type) {
      if (requirement) {
        if (import_yayoyakiValidator.YayoyakiValidator.validateRequirementsSafe(this.samaData.getUserData(), requirement, this.navigationIndex)) {
          return { body, helpButtonUrl: helpButtonUrl == null ? void 0 : helpButtonUrl[0], type };
        }
        return;
      }
      return { body, helpButtonUrl: helpButtonUrl == null ? void 0 : helpButtonUrl[0], type };
    }
  }
  getFilter(index = this.getNavigationIndex()) {
    return this.screenForm.yayoyakiCurrentId ? {
      yayoyakiCurrentId: this.screenForm.yayoyakiCurrentId,
      yayoyakiParentId: this.screenForm.yayoyakiParentId,
      index
    } : void 0;
  }
  getId() {
    return this.screenName;
  }
  getSection() {
    return this.screenForm.section;
  }
  getNavigationIndex() {
    return this.navigationIndex;
  }
  getNext() {
    return this.screenForm.nextScreen;
  }
  getPrevious() {
    return this.screenForm.previousScreen;
  }
  getRenderForm() {
    return {
      bannerData: this.getBannerData(),
      header: this.screenForm.header,
      helpButtonUrl: this.screenForm.helpButtonUrl,
      help: this.screenForm.help,
      path: this.screenForm.path,
      imageUrl: this.screenForm.imageUrl,
      addScreen: this.screenForm.addScreen,
      editScreen: this.screenForm.editScreen,
      nextScreen: this.screenForm.nextScreen,
      previousScreen: this.screenForm.previousScreen,
      screenType: this.screenForm.screenType,
      section: this.getSection(),
      subheader: this.screenForm.subheader,
      upsellingInfo: this.screenForm.upsellingInfo
    };
  }
  isDataValid() {
    const bannerData = this.getBannerData();
    if (bannerData && bannerData.type === import_constants.bannerTypes.ERROR) {
      return false;
    }
    return true;
  }
  isShow() {
    if (!this.screenForm.requirement) {
      return true;
    }
    const value = import_yayoyakiValidator.YayoyakiValidator.validateRequirementsSafe(this.samaData.getUserData(), this.screenForm.requirement, this.navigationIndex);
    return value;
  }
  isChild() {
    return this.screenForm.screenType === import_definition.ScreenTypes.CHILD;
  }
  isTypeSummary(screenForm) {
    return (screenForm == null ? void 0 : screenForm.screenType) === import_definition.ScreenTypes.SUMMARY || (screenForm == null ? void 0 : screenForm.screenType) === import_definition.ScreenTypes.SUMMARY_ADD || (screenForm == null ? void 0 : screenForm.screenType) === import_definition.ScreenTypes.SUBSUMMARY_FILTERED;
  }
  isSummary() {
    return this.isTypeSummary(this.screenForm);
  }
  getCardId() {
    return this.screenForm.cardId;
  }
  isNextSummary() {
    const nextScreen = this.getNext();
    const nextScreenForm = this.samaForm.getScreenForm(nextScreen);
    return this.isTypeSummary(nextScreenForm);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Screen
});
